import authServices from "../services/Auth";
import formValidation from "../validations/FormValidation";

const loginLogic = async (data) => {
  const validation = formValidation.FormValidatiopn(data, "E");
  let dataResp = validation;
  if (!validation.error) {
    const credentials = {
      user: data.user.value,
      password: data.password.value,
      authType: data.authType.value,
    };

    if (credentials.authType === "I") {
      dataResp = authServices.loginService(credentials);
    } else if (credentials.authType === "E") {
      dataResp = authServices.loginServiceUserExt(credentials);
    }
  }
  return dataResp;
};

const refreshTokenLogic = async () => {
  const dataResp = authServices.refreshTokenService();
  return dataResp;
};

const SaveLogLogic = async (data) => {
  const dataResp = authServices.SaveLogService(data);
  return dataResp;
};

const callApiAILogic = async (message) => {
  const request = {
    pregunta: message,
    sessionId: "session123",
  };
  const dataResp = await authServices.callApiAIService(request);
  return dataResp;
};

const authLogic = {
  loginLogic,
  refreshTokenLogic,
  SaveLogLogic,
  callApiAILogic,
};

export default authLogic;
